/**
 * Build a string attribute map from Cognito ID token claims.
 * Federated clients omit aws.cognito.signin.user.admin, so GetUser / bypassCache
 * fails — custom claims (e.g. custom:sf_permissions) still live on the ID token.
 */
export function attributeMapFromIdTokenPayload(payload) {
  if (!payload || typeof payload !== 'object') {
    return {}
  }

  return Object.entries(payload).reduce((attributes, [key, value]) => {
    if (typeof value === 'string') {
      attributes[key] = value
    }
    return attributes
  }, {})
}
